import script from "./DevicesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__